import { FETCH_USER_SUCCESS } from "../actions/userActions";
const initState = {
  data: {
      id_user: 0,
      username: "",
      fullname: "",
      email: "",
      deleted: 0
    }
};

const userReducer = (state = initState, action) => {
  if (action.type === FETCH_USER_SUCCESS) {
    return {
      ...state,
      data: action.payload
    };
  }
  return state;
};

export default userReducer;
